import { ICompanyServicePlan } from "modules/company/types";

export const hasTicketingAccess = (plan: ICompanyServicePlan | null): boolean =>
  plan ? plan.settings.company.ticketing : false;
